function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("path", {
  d: "M1.5 16a.5.5 0 01-.354-.854 6.667 6.667 0 001.8-2.578A6.033 6.033 0 010 7.5C0 3.916 3.589 1 8 1s8 2.916 8 6.5S12.411 14 8 14a10.05 10.05 0 01-1.328-.094A7.893 7.893 0 011.5 16zM8 2C4.141 2 1 4.467 1 7.5a5.137 5.137 0 002.754 4.4.5.5 0 01.246.43 4.539 4.539 0 01-1.255 2.542 7.176 7.176 0 003.391-1.835.489.489 0 01.442-.151A9.253 9.253 0 008 13c3.859 0 7-2.467 7-5.5S11.859 2 8 2z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M18.5 19a7.893 7.893 0 01-5.172-2.094A10.05 10.05 0 0112 17a9.455 9.455 0 01-4.755-1.245.5.5 0 11.51-.86A8.449 8.449 0 0012 16a9.253 9.253 0 001.422-.119.5.5 0 01.441.151 7.278 7.278 0 003.39 1.834A4.542 4.542 0 0116 15.325a.5.5 0 01.246-.43A5.137 5.137 0 0019 10.5a4.769 4.769 0 00-1.827-3.622.5.5 0 11.654-.756A5.737 5.737 0 0120 10.5a6.037 6.037 0 01-2.944 5.069 6.68 6.68 0 001.8 2.577.5.5 0 01-.356.854z"
}),
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
}));

var SvgConversations = function SvgConversations(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgConversations, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Conversations.decd75c5.svg";
export { ForwardRef as ReactComponent };